import { BetResponseCode, BetStatus } from '@pascal/pascal-core';
import { gameService } from '../services';
import { oddStore } from '../store';

export const replayFunction = (repliedBetData) => {
  const handleBetsClosed = gameService.handleBetsClosed;
  const handleDoBetResult = gameService.handleDoBetResult;
  const handleResultReport = gameService.handleResultReport;
  const handleRoundFin = gameService.handleRoundFin;

  const { roundData, gameTypeId, odd } = repliedBetData;
  const minCurrentOdd = 0.1;

  oddStore.setOddData(minCurrentOdd, gameTypeId);
  setTimeout(() => {
    handleDoBetResult({
      ...repliedBetData,
      status: BetStatus.Pending,
      winAmount: 0,
      responseCode: BetResponseCode.Success,
      betData: repliedBetData.additionalParams,
    });
  }, 1000);
  handleBetsClosed({ data: { gameTypeId } });

  setTimeout(() => {
    let currentOdd = minCurrentOdd;
    let isBets = false;
    function printOdd() {
      currentOdd += minCurrentOdd;

      if (currentOdd >= odd && !isBets && repliedBetData.status === BetStatus.Win) {
        handleResultReport({
          data: {
            resultReportData: {
              odd: currentOdd,
              bets: [repliedBetData],
            },
            gameTypeId,
          },
        });
        isBets = true;
      } else {
        handleResultReport({
          data: {
            resultReportData: { odd: currentOdd, bets: [], status: BetStatus.Pending },
            gameTypeId,
          },
        });
      }
      if (currentOdd >= roundData) {
        // eslint-disable-next-line
        clearInterval(intervalId);
        handleRoundFin({ data: { bets: [], finishedRound: repliedBetData } });
      }
    }

    printOdd();

    const intervalId = setInterval(printOdd, 100);
  }, 3000);
};
